import React from 'react';
import { TbArrowBigRightLines } from 'react-icons/tb';

interface NotifySwiperCategoryProps {
    show: boolean;
    onClickConfirm?: CallableFunction;
}

const NotifySwiperCategory = ({
    show,
    onClickConfirm = () => {},
}: NotifySwiperCategoryProps) => {
    if (!show) return null;

    return (
        <div
            onClick={() => onClickConfirm()}
            className='fixed top-[50dvh] right-0 px-6 py-4 z-10 bg-white rounded-l-lg zoomInIcon flex items-center gap-2 shadow cursor-pointer'
            >
            <div className='flex flex-col text-right'>
                <span className='text-sm font-semibold leading-5'>Arraste para a próxima categoria</span>
                <div className='text-sm leading-4 text-shopfood-info'>Fechar</div>
            </div>
            <div>
                <TbArrowBigRightLines size={25} className="animate-drag-right" />
            </div>
        </div>
    )
}

export default NotifySwiperCategory;